<div *ngIf="(authService.isUserLoggedIn() | async) === false as isLoggedOut">
  <p *ngIf="isLoggedOut" class="mb-0 mb-lg-4">
    {{'leadForm.options.alreadyHaveAnAccount' | cxTranslate}}
    <a (click)="logUserIn()" class="focusable focusable__element offset-none" href="javascript:void(0)">
      {{'leadForm.options.logIn' | cxTranslate}}
    </a>
  </p>
</div>
